import { defineStore } from 'pinia';
import sortBy from 'lodash/sortBy';
import { Api } from '@/Api';
import { useDebug } from '@/composables/useDebug';

const { debug } = useDebug();

export interface CampaignModalListItem {
  text: string;
  imageUrl: string;
}

export enum CampaignModalType {
  GENERIC = 'generic',
  UPGRADE = 'upgrade',
}

export enum CampaignModalTarget {
  VIEWER = 'viewer',
  DASHBOARD = 'dashboard',
}

export interface CampaignModalAttributes {
  actionLink: string;
  actionText: string;
  body: string;
  cratedAt: string;
  endTime: string;
  listItems: CampaignModalListItem[];
  modalType: CampaignModalType;
  startTime: string;
  target: CampaignModalTarget[];
  title: string;
  updatedAt: string;
}

export interface CampaignModal {
  id: string;
  attributes: CampaignModalAttributes;
}

export interface CampaignModalState {
  list: CampaignModal[];
  loadedTarget: CampaignModalTarget | null;
}

export const useCampaignModalsStore = defineStore('campaignModalsStore', {
  state: () =>
    ({
      list: [],
      loadedTarget: null,
    }) as CampaignModalState,
  getters: {
    showCampaignModal: state => state.list.length > 0,
    activeCampaignAttributes: state => {
      // DISPLAY MOST RECENT
      // SORT BY startTime
      const sortedCampaigns = sortBy(state.list, [
        function (o) {
          return o.attributes.startTime;
        },
      ]);
      return sortedCampaigns[sortedCampaigns.length - 1]?.attributes;
    },
  },
  actions: {
    async load(target: CampaignModalTarget) {
      try {
        const res = await Api.campaignModal.list(target, true);
        this.list = res.data?.campaignModals || [];
        this.loadedTarget = target;
      } catch (err: any) {
        this.loadedTarget = null;
        debug(err);
      }
    },
    async deleteAll(target: CampaignModalTarget) {
      try {
        await Api.campaignModal.deleteAll(target);
        this.list = [];
        this.loadedTarget = null;
      } catch (err: any) {
        debug(err);
      }
    },
  },
});
